var _a;
import { rgba } from "polished";
import { success, error, borderGreyPrimary } from "@irati/ui/src/global/colors";
import { DealStatus } from "@irati/types";
import { enumToArray } from "@irati/utils/enumToArray";
export var ON = DealStatus.On;
export var OFF = DealStatus.Off;
export var HIDDEN = DealStatus.Hidden;
export var TEST = DealStatus.Test;
export var ARCHIVED = DealStatus.Archived;
export var UNAVAILABLE = DealStatus.Unavailable;
export var SELECT_OPTIONS = enumToArray(DealStatus).map(function (value) { return ({
    value: value,
    label: value
}); });
export var STATUSES = [
    DealStatus.On, DealStatus.Off, DealStatus.Unavailable,
    DealStatus.Hidden, DealStatus.Test, DealStatus.Archived
];
/**
 * Color representations of the deal statuses
 * @type {{}}
 * @private
 */
export var COLOR = (_a = {},
    _a[DealStatus.On] = "" + rgba(success, 0.2),
    _a[DealStatus.Off] = "" + rgba(error, 0.2),
    _a[DealStatus.Unavailable] = "" + rgba("yellow", 0.2),
    _a[DealStatus.Hidden] = "" + rgba("yellow", 0.2),
    _a[DealStatus.Test] = "" + rgba("orange", 0.3),
    _a[DealStatus.Archived] = "" + rgba(borderGreyPrimary, 0.2),
    _a);
export default { ON: ON, OFF: OFF, HIDDEN: HIDDEN, TEST: TEST, UNAVAILABLE: UNAVAILABLE, ARCHIVED: ARCHIVED, SELECT_OPTIONS: SELECT_OPTIONS, STATUSES: STATUSES, COLOR: COLOR };
